import { Box, Typography, Link, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { PRIMARY_COLOR } from "../../constants/color";

export default function GlobalFooter() {
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width:768px)");
  const isProductDetailPage = /^\/products\/[^/]+$/.test(location.pathname);

  return (
    <Box
      component="footer"
      sx={{
        width: isDesktop && isProductDetailPage ? "50%" : "100%",
        backgroundColor: "#f8f9fa",
        borderTop: "1px solid #e9ecef",
        py: 4,
        px: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        {/* Social Media Links - Top Row */}
        <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
          <Link
            href="https://www.instagram.com/koreanstreetmarket/#"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#333",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              "&:hover": {
                color: PRIMARY_COLOR,
                textDecoration: "underline",
              },
            }}
          >
            INSTAGRAM
          </Link>
          <Link
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#333",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              "&:hover": {
                color: PRIMARY_COLOR,
                textDecoration: "underline",
              },
            }}
          >
            YOUTUBE
          </Link>
          <Link
            href="mailto:contact@ksm.com"
            sx={{
              color: "#333",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "500",
              "&:hover": {
                color: PRIMARY_COLOR,
                textDecoration: "underline",
              },
            }}
          >
            CONTACT
          </Link>
        </Box>

        {/* Business Information - Bottom Row */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            217 Av. Eugène Donadeï, 06700 Saint-Laurent-du-Var, CAP3000
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "12px",
            }}
          >
            Korean Street Market
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "12px",
            }}
          >
            Le meilleur de la K-Streetfood
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
